module.exports = __webpack_public_path__ + "media/images/icons/home-34b7911a24701b1698c15f10593a6a8f.svg";